
export enum NavDrawerAction {
    ToggleHierarchy = 1,
    ShowAccount = 2,
    ChangeCustomer = 3,
    ShowHelp = 4,
    SignOut = 5,
    Offline = 6,

    Administration = 7,
    ToggleFavorites = 8,
    ToggleContextualNavDrawer = 9
}
